import React, {createElement, FunctionComponent, useRef} from "react";
import {Box, MenuItem} from "@mui/material";
import {ArrowRight} from "@mui/icons-material";

interface ISubMenuItem {
    menu: FunctionComponent<any>
    onClick: () => void
    onClose: () => void
    open: boolean
    text: string
}
export default function SubMenuItem({menu, onClick, onClose, open, text}: ISubMenuItem) {
    const anchorRef = useRef(null);

    return (
        <div>
            <Box display="flex">
                <MenuItem onClick={onClick}>
                    {text}
                    <ArrowRight/>
                </MenuItem>
                <div ref={anchorRef}/>
            </Box>
            {createElement(menu, {
                parent: anchorRef.current,
                open,
                onClose
            })}
        </div>
    );
}